import React from 'react';
import './ShootingChartTab.scss';
import DynamicIframe from '../Common/DynamicIframe';

const ShootingChartTab = ({ matchDetails }) => {
  const baseUrl =
    process.env.REACT_APP_API_PATH === 'https://dev.api.sketchbball.com'
      ? 'https://dev.stats.sketchbball.com/v2/embed/matches'
      : 'https://stats.sketchbball.com/v2/embed/matches';

  const match_id = matchDetails?.match_id;

  // Don't render if match_id is missing
  if (!match_id) {
    return null;
  }

  const shared_query_params =
    'isDebug=false&showMatchFlow=false&showShotFrequency=false&showScoreBoard=true&showTeamStat=false&showHeadToHead=false&showBoxScore=false&showPlayByPlay=false&showTitle=true&isFixed=true&background=f6f6f6&maxWidth=100%25&frequencyMode=all';
  const shooting_chart_iframe_url = `${baseUrl}/${match_id}?${shared_query_params}`;

  return (
    <div className='shooting-chart-tab'>
      <div className='shooting-chart-header'>
        <h3>Shooting Charts</h3>
        <p>Individual player shooting performance and court positions</p>
      </div>

      <div className='shooting-charts-grid'>
        {/* Team Shooting Charts */}
        <div className='team-shooting-charts'>
          <div className='shooting-chart-iframe'>
            <DynamicIframe url={shooting_chart_iframe_url} className='shooting-chart-embed' />
          </div>
        </div>
      </div>
    </div>
  );
};

export default ShootingChartTab;
